<template>
    <!-- :class="['tab-pane fade', (index === 0 ? 'active in' : 'something_else')]" -->
    <div class="pizza_tilpase_wrap">
        <div class="pizza_prod_info" v-if="!$store.state.skelton">
            <div class="wrap_custom">
                 <span class="back_arrow" @click="go_back()"><i class="fas fa-angle-double-left"></i> {{get_local_string.string_86}}</span>
                <form @submit.prevent="sub()">
                    <div class="row mb-100">
                        <div class="col-lg-6">
                            <div class="left_wrap other_wrap">
                                <!-- Img Item partail from item_info folder -->
                                <itemimgOthertil :getbox_details="get_box_details"></itemimgOthertil>
                                <!-- Item Info Partial From Item_info folder -->
                                <iteminfoOthertil :iteminfoData="custom_obj" :getbox_details="get_box_details"></iteminfoOthertil>
                            </div>
                        </div>
                        <div class="col-lg-6 stepLine">
                            <div class="right_wrap">
                                <!-- select number qty -->
                                <countertil :counterData="custom_obj" :getbox_details="get_box_details" :extra_sum="extra_prices"></countertil>
                                <!-- select pizza type -->
                               <!-- <doughtil :doughData="custom_obj" :getbox_details="get_box_details" :extra_sum="extra_prices">
                               </doughtil> -->
                                <!-- select  pizza  size -->
                                <!-- <sizetil :sizeData="custom_obj" :getbox_details="get_box_details" :extra_sum="extra_prices"></sizetil> -->
                                <!-- edit Components Checkbox  -->
                                <!-- <componentstil :componentsData="custom_obj" :getbox_details="get_box_details" :extra_sum="getextra_prices"></componentstil> -->
                            </div>
                        </div>
                    </div>
                    <template v-if="all_data_cart.status==402">
                         <div class="fixed_add_cart">
                     <b-button outlined class="submit_tulbid" :disabled="true" type="is-success" ><i class="fas fa-shopping-basket mr-1"  aria-hidden="true"></i>{{get_local_string.string_87}}</b-button>
                    </div>
                    </template>
                    <template v-else>
                    <div class="fixed_add_cart">
                     <b-button :price="custom_obj.price"  outlined class="submit_tulbid"   :loading="add_load" type="is-success" native-type="submit"><i class="fas fa-shopping-basket"  aria-hidden="true"></i> {{get_local_string.string_88}} {{custom_obj.price}}{{get_setting_app.payment.currency}}</b-button>
                    </div>
                    </template>
                </form>
            </div>
        </div>
        <!-- ### skellton loader #### -->
        <div class="skellton" v-if="$store.state.skelton">
            <div class="row">
                <div class="col-12">
                    <section>
                        <b-skeleton style="height:100vh" :animated="animated"></b-skeleton>
                    </section>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    // import partail Components ##
    import countertil from '@/components/meny/tilpase/tilpase_block/counter_til';
    // import doughtil from '@/components/meny/tilpase/tilpase_block/dough_til';
    // import sizetil from '@/components/meny/tilpase/tilpase_block/size_til';
    // import componentstil from '@/components/meny/tilpase/tilpase_block/components_til';
    import itemimgOthertil from '@/components/meny/tilpase/tilpase_block/item_info/item_img_other_til';
    import iteminfoOthertil from '@/components/meny/tilpase/tilpase_block/item_info/item_info_other_til';
    
    //End Import Partial CHild #################################### 
    import { mapActions, mapGetters , mapState } from 'vuex';
    import $ from 'jquery';
    export default {
        name: 'other-tilpase',
        data() {
            return {
                animated: true,
                add_load:false,
                custom_obj: {
                    food_id: null,
                    default:0,
                    dough_id: null,
                    size_id: null,
                    qty: 1,
                    component: [],
                    extra: [],
                    price: null,
                    platform:'web'
                },
                extra_prices: 0

            }
        },
        //  doughtil , sizetil , componentstil 
        components:{countertil , itemimgOthertil , iteminfoOthertil},
        methods: {
            ...mapActions({
                box_details: 'box_details',
                add_to_cart:'add_to_cart',
            }),
           //function on submit page custom
           sub() {
                this.add_load = true;
                this.add_to_cart(this.custom_obj).then(()=>{
                    setTimeout(() => {
                       this.$router.go(-1);
                          this.uk.offcanvas($('#offcanvas-flip')).show();
                          $('.list_added_item').find('.move_left').removeClass('modify');
                          this.add_load = false;     
                    }, 1000);
                })
            },
            // set Default From Api To Page such as dought and size id etc...
            fetchData_local() {
                // default value from api
                this.custom_obj.dough_id = this.custom_pizza.dough_id;
                this.custom_obj.price = this.custom_pizza.price;
                this.custom_obj.size_id = this.custom_pizza.size_id;
                // set default class in pizza from data attr
                $('.image_prod img').addClass($('.size_buttons input').first().attr('data-class'));
                // set default prod title from data attr
                $('.size_item').text($('.size_buttons input').first().attr('data-title'));
                this.custom_obj.food_id = this.custom_pizza.food_id;
                this.custom_obj.component = this.custom_pizza.component;

            },
            // show all child checkbox if parents is main components 
            Checked_comp() {
                for (let input of this.custom_obj.component) {
                    $(`.extra-${input}`).parents('.double_extra').show();
                }
            },
            //    animation_button(){
            //     let addToCartButton = document.querySelector(".add-to-cart-button");
            //       addToCartButton.classList.add('added');
            // },
            // remove_animation_button(){
            //      let addToCartButton = document.querySelector(".add-to-cart-button");
            //      addToCartButton.classList.remove('added');
            // },
            go_back(){
                this.$router.go(-1);
            }
            
        },
        computed: {
            ...mapGetters({
                get_box_details: 'get_box_details',
                  all_data_cart:'all_data_cart',
                   get_setting_app:'get_setting_app',
                     get_local_string:'get_local_string'
            }),
            ...mapState({
                custom_pizza: 'custom_pizza'
            }),
            getextra_prices(){
                return this.extra_prices
            }
        },
        created() {
            this.box_details(this.$route.params.id).then(() => {
                this.fetchData_local();
                this.Checked_comp();
            });
        }
    }
</script>
<style lang="scss" scoped>
   .pizza_tilpase_wrap  .skellton {
        position: absolute;
        top: 80px;
        left: 0px;
        width: 100%;
        height: 100%;
    }
    .pizza_tilpase_wrap  .b-skeleton-item {
        height: 100vh;
    }
</style>